const style = {
  button:{
    primary:"mx-auto px-2 py-1 inline-block bg-dulo text-white font-body rounded font-bold border-2 border-dulo",
    secondary:"mx-auto px-3 py-2 inline-block bg-transparent text-dulo font-body rounded font-bold border-dulo border-2"
  }
}

export default style;